/* src/app/app.component.css */
.environment-warning {
  color: #FFF;
  padding: 5px;
  background: #ffc107;
  text-align: center;
  font-family:
    Roboto,
    "Helvetica Neue",
    sans-serif;
}
/*# sourceMappingURL=app.component-QPZTAGAM.css.map */
